import React from 'react';
import PropTypes from 'prop-types';
import TextFormatter from 'utils/TextFormatter';
import Divider from 'material-ui/Divider';

class CommercialSummary extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.handleSelectedPhoneNumberChanged = this.handleSelectedPhoneNumberChanged.bind(this);

        this.state = {
            selectedPhoneNumber: ''
        };
    }

    componentWillMount(){
        const {commercialDetails} = this.props;
        if (this.state.selectedPhoneNumber === '' && commercialDetails && commercialDetails.get('commercialPdaEquipmentInfo') && commercialDetails.get('commercialPdaEquipmentInfo').count() > 0)
        {
            const firstNumber = commercialDetails.get('commercialPdaEquipmentInfo').first().get('telephonE_NUMBERS');
            this.setState({selectedPhoneNumber: firstNumber});
        }
    }

    handleSelectedPhoneNumberChanged(e)
    {
        this.setState({selectedPhoneNumber: e.target.value});       
    }

    render() {  
        const {commercialDetails} = this.props;    
      
        if (commercialDetails === undefined || commercialDetails === null ||
            commercialDetails.get('commercialPdaCustomerInfo') === null || 
            commercialDetails.get('commercialPdaEquipmentInfo') === null || 
            commercialDetails.get('commercialPdaFeatures') === null ) {
            return (<div><h6>Commercial Data Unavailable or Incomplete</h6></div>);
        }

        const tdStyle = {
            border: '1px solid black'
        };

        const tableStyle = {
            borderCollapse: 'collapse'
            
        };

        const spacingBottomStyle = {
            marginBottom: '20px'
        };
        
        const filteredFeatures = commercialDetails
        .get('commercialPdaFeatures')
        .filter((item) => {
            return item.get('tn') === this.state.selectedPhoneNumber;
        });

        const features =  (
                <div>
                    <h5>
                        Features - {TextFormatter.formatPhoneNumber(this.state.selectedPhoneNumber)}
                    </h5>
                    <table className="striped" style={tableStyle}>
                        <thead>
                            <tr>
                                <th>TN</th>
                                <th>Feature</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredFeatures.map((item, rowIndex) => {
                                return (
                                    <tr key={`feature_row_${rowIndex}`}>
                                        <td style={tdStyle}>{item.get('tn')}</td>
                                        <td style={tdStyle}>{item.get('feature')}</td>
                                        <td style={tdStyle}>{item.get('value')}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            );
      


        const phoneOptions = (
            commercialDetails
                .get('commercialPdaEquipmentInfo')
                .map((item, index) => {
                    return (
                        <option 
                            value={item.get('telephonE_NUMBERS')}
                            key={'phoneNumber' + index}
                            style={{
                                fontSize: '10px'
                            }}>
                            {TextFormatter.formatPhoneNumber(item.get('telephonE_NUMBERS'))}
                        </option>
                    );
                })
        );

        const phoneNumbers = (
            <div style={spacingBottomStyle}>
                <h5>Phone Numbers</h5>

                <select
                    disabled={false}
                    className="browser-default"
                    value={this.state.selectedPhoneNumber}
                    onChange={this.handleSelectedPhoneNumberChanged}>
                    {phoneOptions}
                </select>

            </div>
        );

        const equipment = (
            <div>
                <h5>Equipment</h5>
                <table className="striped" style={tableStyle}>
                    <thead>
                        <tr>
                            <th>Equipment</th>
                            <th>Make/Model</th>
                            <th>Line ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {commercialDetails
                            .get('commercialPdaEquipmentInfo')
                            .map((item, equipmentIndex) => {
                                return (
                                    <tr key={`equipment_row_${equipmentIndex}`}>
                                        <td style={tdStyle}>{item.get('equipment')}</td>
                                        <td style={tdStyle}>{item.get('make')}<br/>{item.get('model')}</td>
                                        <td style={tdStyle}>{item.get('lineid')}</td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>

            </div>
        ); 

        return (            
            <div className="row padx2" id="wow-fst-commercial-summary">
                <Divider/>
                <div className="col s12">
                    <h5 className="center-align">Commercial Order Summary</h5>
                    
                    <div className="row padx2">
                        <div className="col s12">
                            <table className="striped condensed" style={tableStyle}>
                                <tbody>
                                    <tr>
                                        <td style={tdStyle}>
                                            Order Id:
                                        </td>
                                        <td style={tdStyle}>{commercialDetails.getIn(['commercialPdaCustomerInfo', 'order_id'])}</td>
                                    </tr>
                                    <tr>
                                        <td style={tdStyle}>Address</td>
                                        <td style={tdStyle}>    
                                            {commercialDetails.getIn(['commercialPdaCustomerInfo', 'address1'])}&nbsp;{commercialDetails.getIn(['commercialPdaCustomerInfo', 'address2'])}<br/> 
                                            {commercialDetails.getIn(['commercialPdaCustomerInfo', 'city'])},&nbsp;{commercialDetails.getIn(['commercialPdaCustomerInfo', 'state'])}
                                            &nbsp;{commercialDetails.getIn(['commercialPdaCustomerInfo', 'zip'])}<br/> 
                                            {TextFormatter.formatPhoneNumber(commercialDetails.getIn(['commercialPdaCustomerInfo', 'primary_telephone_number']))}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={tdStyle}>
                                            Address Id:
                                        </td>
                                        <td style={tdStyle}>{commercialDetails.getIn(['commercialPdaCustomerInfo', 'addressId'])}</td>
                                    </tr>
                                </tbody>
                            </table>
                        
                            <br/>
                        </div>
                    </div>
                    {equipment}
                    {phoneNumbers}                    
                    {features}
                </div>
            </div>
        );

    }

}

CommercialSummary.propTypes = {
    commercialDetails: PropTypes.object
};

export default CommercialSummary;


// WEBPACK FOOTER //
// ./src/components/work-order/CommercialSummary.js